import React from "react";
import { LANDING } from "../constants/testIds/landing";
import { BookOpen, ArrowRight } from "lucide-react";

export const Hero = ({ t }) => {
  return (
    <section
      id="home"
      className="relative min-h-[90vh] flex items-center justify-start bg-[#efe7dd] overflow-hidden"
    >
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={`${process.env.PUBLIC_URL}/images/hero-bg.jpg`}
          alt="Argentine Tango Elegance"
          className="w-full h-full object-cover object-center opacity-30 scale-105 transform hover:scale-100 transition-transform duration-10000"
        />
        {/* Soft, rich gradients to create depth and warmth */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#efe7dd] via-[#efe7dd]/85 to-transparent z-10" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#efe7dd] via-transparent to-[#efe7dd]/40 z-10" />
      </div>

      {/* Portrait Walter & Regina (top right) */}
      <div className="hidden lg:block absolute top-28 right-8 xl:right-16 z-20 w-64 xl:w-80 animate-fadeIn">
        <div className="relative group">
          <div className="absolute -inset-2 bg-gradient-to-tr from-[#8a2424] to-[#d97036] opacity-30 blur-lg group-hover:opacity-40 transition-opacity duration-500" />
          <div className="relative border border-[#b58e70]/40 bg-[#1f1612] p-2 shadow-2xl">
            <img
              src={`${process.env.PUBLIC_URL}/images/hero-portrait.jpg`}
              alt="Walter & Regina beim Tango"
              data-testid={LANDING.heroPortrait}
              className="w-full h-auto object-cover select-none"
            />
          </div>
        </div>
      </div>

      {/* Content Container (Asymmetric, Left-aligned for premium editorial feel) */}
      <div className="relative z-20 max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-24 md:py-36 w-full flex flex-col items-start justify-end h-full">
        <div className="max-w-3xl space-y-8 animate-fadeIn">
          {/* Accent golden/brown uppercase tag */}
          <span className="font-sans text-xs sm:text-sm tracking-[0.3em] uppercase text-[#d97036] font-medium block">
            {t.hero.subtitle}
          </span>

          <h1
            data-testid={LANDING.heroTitle}
            className="font-serif text-5xl sm:text-6xl lg:text-7xl xl:text-8xl text-[#1c110e] tracking-tight leading-[1.05] font-light"
          >
            {t.hero.title}
          </h1>

          <p
            data-testid={LANDING.heroSubtitle}
            className="font-sans text-lg sm:text-xl text-[#5a4b46] leading-relaxed max-w-2xl font-light"
          >
            {t.hero.tagline}
          </p>

          <p className="font-sans text-sm sm:text-base text-[#5a4b46]/90 leading-relaxed max-w-xl font-light">
            {t.hero.description}
          </p>

          {/* Action Buttons (Sharp corners, elegant borders) */}
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 pt-6">
            <a
              href="#contact"
              data-testid={LANDING.heroContactCta}
              className="bg-[#8a2424] text-[#efe7dd] hover:bg-[#a32e2e] transition-colors duration-300 px-8 py-4 uppercase tracking-[0.25em] text-xs font-semibold text-center border border-[#8a2424] hover:border-[#a32e2e]"
            >
              {t.hero.ctaContact}
            </a>
            <a
              href="#book"
              data-testid={LANDING.heroBookCta}
              className="border border-[#8a2424] text-[#8a2424] hover:bg-[#8a2424] hover:text-[#efe7dd] transition-all duration-300 px-8 py-4 uppercase tracking-[0.25em] text-xs font-semibold flex items-center justify-center gap-2 text-center"
            >
              <BookOpen className="w-4 h-4" />
              {t.hero.ctaBook}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
